import { Input } from "@/components/ui/input";
import { DONATE } from "@/constants/testIds";

const PRESETS = [15, 35, 75, 150];

export function AmountSelector({ frequency, selectedPreset, useCustom, customAmount, onSelectPreset, onToggleCustom, onCustomAmountChange }) {
  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        {PRESETS.map((p) => (
          <button
            key={p}
            onClick={() => onSelectPreset(p)}
            data-testid={DONATE.packageCard(`amt_${p}`)}
            className={`rounded-sm border p-5 text-center transition-all ${!useCustom && selectedPreset === p ? "bg-[#4FD1C5]/10 border-[#1E3A6E]" : "bg-white border-zinc-200 hover:border-zinc-400"}`}
          >
            <p className="font-display font-black text-2xl text-zinc-950">${p}</p>
            {frequency === "monthly" && <p className="text-xs text-zinc-500">/month</p>}
          </button>
        ))}
      </div>

      <button
        onClick={onToggleCustom}
        data-testid="donate-custom-amount-toggle"
        className={`w-full rounded-sm border p-4 text-center mb-8 transition-all ${useCustom ? "bg-[#4FD1C5]/10 border-[#1E3A6E]" : "bg-white border-zinc-200 hover:border-zinc-400"}`}
      >
        <div className="flex items-center justify-center gap-2">
          <span className="text-zinc-600 text-sm font-medium">Custom amount:</span>
          <span className="text-zinc-950 font-bold">$</span>
          <Input
            type="number" min="1" step="1" placeholder="0"
            value={customAmount}
            onChange={(e) => onCustomAmountChange(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            data-testid="donate-custom-amount-input"
            className="w-28 text-center bg-white border-zinc-300 rounded-none focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5]"
          />
          {frequency === "monthly" && <span className="text-zinc-500 text-sm">/month</span>}
        </div>
      </button>
    </>
  );
}
